import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
} from '@angular/forms';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config';
import { AppConfig, Scheme, Theme, Themes } from 'app/core/config/app.config';
import { Subject, takeUntil } from 'rxjs';
import { EncryptdecryptService } from 'app/shared/services/encryptdecrypt.service';
import { mydetailService } from 'app/modules/mydetail/mydetail.service';
import { Layout } from 'app/layout/layouts/layout.types';
import { forkJoin } from 'rxjs';
import { CustomerVerificationservice } from 'app/modules/CustomerVerification/CustomerVerification.service';
import { User } from 'app/core/user/user.types';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'app-global-customer-search',
    templateUrl: './global-customer-search.component.html',
    styles: [
        `
            app-global-customer-search {
                position: static;
                display: block;
                flex: none;
                width: auto;
            }

            @media (screen and min-width: 1280px) {
                empty-layout + app-global-customer-search .settings-cog {
                    right: 0 !important;
                }
                /* empty-layout + settings .settings-cog {
                right: 0 !important;
            } */
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class GlobalCustomerSearchComponent implements OnInit {
    config: AppConfig;
    layout: Layout;
    scheme: 'dark' | 'light';
    theme: string;
    themes: Themes;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    Globalfrom: UntypedFormGroup;
    submitted = false;
    CoreSPID: string;
    SPID: string;
    AccountId: Number;
    encryptstring: string = "";
    AccountIds: string = "";
    user: User;
    vaidaccountnumber: boolean = false;

    constructor(
        private _router: Router,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: UntypedFormBuilder,
        private _globalSerch: mydetailService,
        private EncrDecr: EncryptdecryptService,
        private _CustomerVerificationservice: CustomerVerificationservice,
        private _authService: AuthService
    ) { }

    ngOnInit() {
        this._fuseConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config: AppConfig) => {
                // Store the config
                this.config = config;
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    async onglobalFormSubmit(drawer: any) {
        drawer.close();

        this.user = JSON.parse(this._authService.accessUser);

        this.AccountId = Number(
            (<HTMLInputElement>document.getElementById('Accountno')).value
        );
        this.CoreSPID = String(
            (<HTMLInputElement>document.getElementById('CoreSPID')).value
        );
        this.SPID = String(
            (<HTMLInputElement>document.getElementById('SPID')).value
        );

        if (
            (this.AccountId != null && this.AccountId != 0) ||
            (this.CoreSPID != null && this.CoreSPID != '') ||
            (this.SPID != null && this.SPID != '')
        ) {
            if (this.AccountId != null && this.AccountId != 0) {
                const res: any = await this._CustomerVerificationservice.cvAccountno(Number(this.AccountId), this.user.id).toPromise();
                if (res.errorCode == 1) {

                    if (this.CoreSPID != null && this.CoreSPID != "") {
                        // this.SPID = '';
                        this.AccountId = 0;
                    }
                    else if (this.SPID != null && this.SPID != "") {
                        this.CoreSPID = "";
                        this.AccountId = 0;
                    }
                    else {
                        alert("Please enter a valid Account No.");
                        (document.getElementById('Accountno') as HTMLInputElement).value = "";
                        (document.getElementById('CoreSPID') as HTMLInputElement).value = "";
                        (document.getElementById('SPID') as HTMLInputElement).value = "";
                        return;
                    }


                }
                else if (res.errorCode == 0) {
                    if (this.AccountId != null && this.AccountId != 0) {
                        const filledFields = [this.AccountId, this.CoreSPID, this.SPID].filter(value => value && value !== '').length;
                        if (filledFields >= 2) {
                            this.CoreSPID = '';
                            this.SPID = '';
                        }
                    }
                }

            }

            if (this.CoreSPID != null && this.CoreSPID != "") {

                
                const res: any = await this._CustomerVerificationservice.VerifySpid(this.CoreSPID, this.user.id, "CoreSPID").toPromise();
                if (res.errorCode == 1) {

                    if (this.SPID != null && this.SPID != "") {
                        this.CoreSPID = '';
                        this.AccountId = 0;
                    }

                    else {
                        alert("Please enter a valid Core SPID.");
                        (document.getElementById('Accountno') as HTMLInputElement).value = "";
                        (document.getElementById('CoreSPID') as HTMLInputElement).value = "";
                        (document.getElementById('SPID') as HTMLInputElement).value = "";
                        return;

                    }


                }
                else if (res.errorCode == 0) {
                    
                    if (this.CoreSPID != null && this.CoreSPID != "") {
                        const filledFields = [this.AccountId, this.CoreSPID, this.SPID].filter(value => value && value !== '').length;
                        if (filledFields >= 2) {

                            this.SPID = '';
                            this.AccountId = 0;
                        }
                    }
                }

            }
            if (this.SPID != null && this.SPID != "") {
           
                const res: any = await this._CustomerVerificationservice.VerifySpid(this.SPID, this.user.id, "SPID").toPromise();
                if (res.errorCode == 1) {




                    alert("Please enter a valid SPID.");
                    (document.getElementById('Accountno') as HTMLInputElement).value = "";
                    (document.getElementById('CoreSPID') as HTMLInputElement).value = "";
                    (document.getElementById('SPID') as HTMLInputElement).value = "";
                    return;




                }
                else if (res.errorCode == 0) {
                    
                    if (this.SPID != null && this.SPID != "") {
                        const filledFields = [this.AccountId, this.CoreSPID, this.SPID].filter(value => value && value !== '').length;
                        if (filledFields >= 2) {

                            this.CoreSPID = '';
                            this.AccountId = 0;
                        }
                    }
                }
            }

            this.encryptAndNavigate();


        } else {
            alert('Enter any one.');
        }
    }
    onKeyDown(event: KeyboardEvent): void {
        if (event.key === ' ') {
            event.preventDefault(); // Prevent spacebar from being added
        }
    }
    Clear() {
        (document.getElementById('Accountno') as HTMLInputElement).value = "";
        (document.getElementById('CoreSPID') as HTMLInputElement).value = "";
        (document.getElementById('SPID') as HTMLInputElement).value = "";
    }
    validateNumber(event) {
        const pattern = /^[0-9]*$/;
        if (!pattern.test(event.target.value)) {
            event.target.value = event.target.value.replace(/[^0-9]/g, '');
            this.AccountId = Number(event.target.value);

        }

    }
    validate(event) {
        const pattern = /^[a-zA-Z0-9]*$/;
        if (!pattern.test(event.target.value)) {
            event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
            this.CoreSPID = event.target.value;

        }

    }
    async validateAccount() {
        try {
            const res: any = await this._CustomerVerificationservice.cvAccountno(Number(this.AccountId), this.user.id).toPromise();
            if (res.errorCode == 1) {
                alert("Please enter a valid Account No.");
                return;
            }
          
        } catch (error) {
            console.error("API Error: ", error);
        }
    }
    close(drawer: any) {
        (document.getElementById('Accountno') as HTMLInputElement).value = "";
        (document.getElementById('CoreSPID') as HTMLInputElement).value = "";
        (document.getElementById('SPID') as HTMLInputElement).value = "";
        drawer.close();
    }
    async encryptAndNavigate() {
        try {

    
            // Convert Observables to Promises
            const encryptedValues = await Promise.all([
                this.AccountId ? this.EncrDecr.getEncryptid(this.AccountId).toPromise() : Promise.resolve({ encryptedText: '0' }),
                this.CoreSPID ? this.EncrDecr.getEncryptid(this.CoreSPID).toPromise() : Promise.resolve({ encryptedText: '' }),
                this.SPID ? this.EncrDecr.getEncryptid(this.SPID).toPromise() : Promise.resolve({ encryptedText: '' })
            ]);

            // Assign encrypted values
            this.AccountIds = encryptedValues[0].encryptedText;
            this.CoreSPID = encryptedValues[1].encryptedText;
            this.SPID = encryptedValues[2].encryptedText;

            
            if (this.AccountIds == "0") {
                this.AccountIds = 'AccountId';
            }
            this.Clear();
            this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this._router.navigate([
                    'CustomerVerification/globalsearch',
                    this.AccountIds || 'AccountId',
                    this.CoreSPID || 'CoreSPID',
                    this.SPID || 'SPID'
                ]);
            });


        } catch (error) {
            console.error('Encryption API Error:', error);
        }
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Set the layout on the config
     *
     * @param layout
     */
    setLayout(layout: string): void {
        this._router
            .navigate([], {
                queryParams: {
                    layout: null,
                },
                queryParamsHandling: 'merge',
            })
            .then(() => {
                // Set the config
                this._fuseConfigService.config = { layout };
            });
    }

    /**
     * Set the scheme on the config
     *
     * @param scheme
     */
    setScheme(scheme: Scheme): void {
        this._fuseConfigService.config = { scheme };
    }

    /**
     * Set the theme on the config
     *
     * @param theme
     */
    setTheme(theme: Theme): void {
        this._fuseConfigService.config = { theme };
    }
}

